import { Breadcrumb, Button, Col, Form, Row, Steps } from "antd";
import { _adr } from "../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import ResizeImage from "../../auxiliary/resizeImg/resizeImage";
import { validateInput } from "../../../tools/tools";

const CDUpload = () => {
	const [t] = useTranslation("global");
	const [frmProfile] = Form.useForm();

	const handleSubmit = () => {};
	return (
		<>
			<div className="container-main container-cw">
				<div className="holder-top-of-page-content">
					<div className="g-hold-title-of-page">
						<Breadcrumb
							className="breadcrumbs"
							items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("creditCard.title") }]}
						/>
						<div className="title-page">
							<h3>{t("creditCard.title")}</h3>
							<p></p>
						</div>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main da-container">
						<div className="g-format-page">
							<div className="g-format-steps">
								<div className="holder-step">
									<Steps
										size="small"
										className="step-wizard"
										current={2}
										responsive
										items={[
											{
												title: "ورود کدملی",
											},
											{
												title: "اطلاعات هویتی",
											},
											{
												title: "آپلود مدارک",
											},
											{
												title: "کارت بانکی",
											},
											{
												title: "بررسی نهایی",
											},
										]}
									/>
								</div>
							</div>
							<div className="g-body-format-page">
								<br />
								<div className="page_title">آپلود پاسپورت</div>
								<br />
								<Form id="frmProfile" form={frmProfile} onFinish={handleSubmit} layout="vertical">
									<Row gutter={30}>
										<Col xs={24} sm={12} md={24} lg={12} xl={10}>
											<Form.Item name="photo" rules={[validateInput({ t: t, validate: true })]} label="">
												<ResizeImage exportImage={() => {}} />
											</Form.Item>
										</Col>
										{/* <Col span={9} style={{ margin: "auto 0" }}>
                          <ul>
                            <li>بارگذاری کارت ملی جدید یا شناسنامه جدید یا کارت ملی قدیمی همراه با رسید کارت ملی جدید</li>
                            <li>فرمت ها و حجم و رزولوشن قابل قبول</li>
                            <li>توضیح در مورد مشخص بودن گوشه های تصویر مدارک</li>
                          </ul>
                        </Col> */}
									</Row>
									<br />
									<div className="page_title">آپلود قرارداد</div>
									<br />
									<Row gutter={30}>
										<Col xs={24} sm={12} md={24} lg={12} xl={10}>
											<Form.Item name="photo" rules={[validateInput({ t: t, validate: true })]} label="">
												<ResizeImage exportImage={() => {}} />
											</Form.Item>
										</Col>
										{/* <Col span={9} style={{ margin: "auto 0" }}>
                          <ul>
                            <li>بارگذاری کارت ملی جدید یا شناسنامه جدید یا کارت ملی قدیمی همراه با رسید کارت ملی جدید</li>
                            <li>فرمت ها و حجم و رزولوشن قابل قبول</li>
                            <li>توضیح در مورد مشخص بودن گوشه های تصویر مدارک</li>
                          </ul>
                        </Col> */}
									</Row>
								</Form>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button
										// disabled={10 - prof.counterSim > 0 ? false : true}
										form="frmProfile"
										key="submit"
										htmlType="submit"
										className="btn-normal btn-aptel">
										مرحله بعد
									</Button>
									<Button
										type="default"
										className="btn-normal "
										onClick={() => {
											// nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Kit);
										}}>
										بازگشت
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>
		</>
	);
};

export default CDUpload;
